<template>
  <ul class="subnav">
    <router-link
        v-for="batch in batches"
        :key="batch.batchId"
        :to="{name: 'BatchShow', params: {id: batch.batchId}}">
      <li class="multiline">
        <label>{{
            (batch.incomingStockLocation ? batch.incomingStockLocation +' ' : '')+
            batch.uniqueNumber + (batch.number ? '/'+ batch.number : '') + ' ' + getSupplier(batch.supplierId)
          }}</label>
        <span v-if="batch.dryerId && dryersAmount > 1">{{ getDryerName(batch.dryerId) }}</span>
        <br/>
        <span v-if="products.length > 1">{{ getProduct(batch.productId) }} </span>
        {{ showRegraters ? 'für '+ getRegrater(batch.regraterId) : '' }}
        <span v-if="batch.driedStartDateTime"><br/>gestartet: {{ getFormattedDateTime(batch.driedStartDateTime) }}</span>
        <!--        at <app-date-time :timestamp="batch.publishedAt"/>-->
        <!-- <img src="@/assets/images/pit-story_arrow.svg"> -->
      </li>
    </router-link>
  </ul>
  <div v-if="addBatchEnabled">
    <button @click="showEditor">Neue Charge</button>
    <batch-editor v-if="edit"/>
    <!--  <batch-editor v-if="edit" @save="addBatch"/>-->
  </div>

</template>

<script>
import BatchEditor from "@/components/BatchEditor";
import dayjs from "dayjs";

export default {
  name: "BatchList",
  components: {
    BatchEditor
  },
  props: {
    batches: {
      required: false,
      type: Array
    },
    addBatchEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
    showRegraters: {
      required: false,
      default: true
    }
  },
  data() {
    return {
      edit: false
    }
  },
  computed: {
    dryersAmount() {
      return this.$store.getters.dryersAmount
    },
    dryers() {
      return this.$store.getters.dryers
    },
    products() {
      return this.$store.state.product
    },
  },
  methods: {
    showEditor() {
      this.edit = true;
    },
    // addBatch(eventData) {
    // const batch = {
    //   ...eventData.batch
    // }
    // this.batches.push(batch)
    // },
    hasHistory(batch) {
      return batch.history?.length
    },
    getSupplier(id) {
      return this.$parent.getSupplier(id)
    },
    getRegrater(id) {
      return this.$parent.getRegrater(id)
    },
    getFormattedDateTime(datetime) {
      return dayjs(datetime + ' +00:00', 'YYYY-MM-DD HH:mm:ss Z').format('DD.MM.YYYY HH:mm')+ ' Uhr'
    },
    getDryerName(dryerId) {
      if (this.dryers)
        return ' → '+ this.dryers[dryerId]

      return ' → Trockner '+ dryerId
    },
    getProduct(id) {
      if (!id || !this.$store.state.product) return '–'
      const item = this.$store.state.product.find(item => item.productId === id)
      if (!item) return '–'
      return item.name
    },
  }
}
</script>

<style scoped>

</style>